module.exports = __webpack_public_path__ + "media/src/images/progress/paylight-dc7cc8ce8591995442b45cda6f5ada7d.jpg";